import { types } from "../types/types";
const intitalState = {
    termsAndConditions: {},
    privacyPolicy: {},
    faq: [],
};

const contentReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.TERMS_AND_CONDITIONS:
            return {
                ...state,
                termsAndConditions: action.payload,
            };
        case types.PRIVACY_POLICY:
            return {
                ...state,
                privacyPolicy: action.payload,
            };
        case types.FAQ:
            return {
                ...state,
                faq: action.payload,
            };
        default:
            return { ...state };
    }
};

export default contentReducer;
